import StreamsLayout from './StreamsLayout';

export default StreamsLayout;
